import { Button, Text } from 'grommet'
import { FormDown, FormUp } from 'grommet-icons'

export type AdvancedLineProps = {
  isOpened: boolean
  onToggle: () => void
  labelText: string
}

export default function AdvancedLineButton({ isOpened, onToggle, labelText }: AdvancedLineProps) {
  return (
    <Button
      plain
      reverse
      onClick={onToggle}
      icon={isOpened ? <FormUp /> : <FormDown />}
      label={<Text size="small">{labelText}</Text>}
    />
  )
}
